import MethodReducerGenerator from './MethodReducerGenerator'

export default class UpdateReducerGenerator extends MethodReducerGenerator {
  constructor(name, basePath) {
    super('UPDATE', name, basePath)
  }

  static initialState = {
    requestInProgress: false,
    requestComplete: false,
    updated: false,
    generalError: undefined,
    resourceErrors: undefined,
    attributes: undefined,
    id: undefined,
    responseHeaders: undefined
  }

  requestHandler(state, action) {
    return { ...state,
      requestInProgress: true,
      requestComplete: false,
      updated: false,
      attributes: action.attributes,
      id: action.id }
  }

  responseHandler(state, action) {
    return { ...state,
      requestInProgress: false,
      requestComplete: true,
      updated: true,
      id: action.id,
      responseHeaders: action.responseHeaders,
      resourceErrors: null }
  }

  errorHandler(state, action) {
    return { ...state,
      requestInProgress: false,
      requestComplete: true,
      updated: false,
      generalError: action.generalError,
      resourceErrors: action.resourceErrors }
  }
}
